/* eslint-disable import/prefer-default-export */
import { useSelector } from "react-redux";
import { connectServicesActivationModalInitialState } from "./addonsReducer";

// The slice is client-only — Rails never preloads an `addons` key — so hand-built
// test/story states routinely omit it entirely. Fall back on both a missing slice
// and a missing key so consumers always read a well-formed modal state.
// eslint-disable-next-line import/prefer-default-export
export const useConnectServicesActivationModalState = () =>
  useSelector(
    (state) => state.addons?.connectServicesActivationModal ?? connectServicesActivationModalInitialState,
  );
